/* eslint-disable no-magic-numbers */
import { GIGA } from "utils/common";
import { imageMaxBytes, videoMaxBytes } from "widgets/social2/utils";

export const MAX_VIDEO_BYTES = videoMaxBytes(4 * GIGA);
export const MAX_THUMBNAIL_BYTES = imageMaxBytes();

export const MIN_VIDEO_SEC = 0;
export const MAX_VIDEO_MIN = 15;
